import type { SolarProposalSavingsSectionDto } from "~/api/dto/solar-proposal-savings.dto"

import { SectionNotice } from "./SectionNotice"
import { UtilitySavings } from "./sections/savings"
import type { SolarSectionState } from "./solar-presentation-data"
import { toSolarUtilitySavings } from "./solar-proposal-savings"

/**
 * "The math". The savings read loads and fails on its own, so the sections
 * above it stay rendered whatever happens here. Out-of-date savings keep their
 * figures; the seller page marks them `stale` and its Updates panel offers the
 * recalculation. Without savings there's no section at all.
 */
export const SolarSavingsSection = ({
  proposalId,
  state,
  stale = false,
  initialYear,
  computeMonthlyBase = null,
}: {
  proposalId: string
  state: SolarSectionState<SolarProposalSavingsSectionDto>
  /** Seller page only: underline the figures as out of date. */
  stale?: boolean
  /** The year the dial opens on; the print route sets it. */
  initialYear?: number
  /** The compute section's guaranteed base; savings count the node only when theirs matches. */
  computeMonthlyBase?: number | null
}): JSX.Element | null => {
  if (state.status !== `ready`) {
    return <SectionNotice id="savings" state={state} noun="your savings" />
  }

  const { savings, net } = state.data
  if (!savings) return null

  return (
    <UtilitySavings
      // Another proposal's savings start the year dial over.
      key={proposalId}
      savings={toSolarUtilitySavings(savings, net, computeMonthlyBase)}
      stale={stale}
      initialYear={initialYear}
    />
  )
}
